/* eslint-disable */
import { Component } from 'react';
import {Alert} from 'react-bootstrap';
import DOMPurify from 'dompurify';

import './error-messages.css';

class ErrorMessages extends Component {
  constructor(props) {
    super(props);
    
    const regex = /{{(\s\d+\s)}}/g;
    const str = this.props.children;
    let m,
      countdown;
    
    while ((m = regex.exec(str)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      
      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        if (groupIndex === 1) {
          countdown = +match;
        }
      });
    }
    
    this.tick = this.tick.bind(this);
    let message = props.children;
    
    if (countdown) {
      this.timer = setInterval(this.tick, 1000);
      message = props.children.replace(/{{(\s.+\s)}}/g, this.parseTime(countdown));
    }
    
    this.state = {
      login: {
        countdown
      },
      children: message
    };
  }
  
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  
  parseTime(time) {
    let minutes = Math.floor(time / 60);
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    let seconds = time % 60;
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    
    return `${minutes}:${seconds}`;
  }
  
  tick() {
    const time = this.state.login.countdown - 1;
    if (time === 0) {
      clearInterval(this.timer);
    }
    
    const counterMessage = this.state.children.replace(/\d{2}:\d{2}/g, this.parseTime(time));
    
    this.setState({
      login: {
        countdown: time,
      },
      children: counterMessage
    });
  }
  
  render() {
    const { children } = this.state;

    return (
      // <Panel className="errors" bsStyle="danger">
      <Alert variant="danger" className="notiny-animation-show">
        <i className="fa fa-exclamation-triangle icon-shake" aria-hidden="true"/>
        <span className="error-message" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(children)}}/>
      </Alert>
    );
  }
}

export default ErrorMessages;
